import React from "react";
import {useMessages} from "i18n";
import {EdgeTab} from "./FeedbackEdgeTab.styles";

interface FeedbackEdgeTabProps {
	/**
	 * Opens the support surface. Deliberately a callback rather than a dialog of its own: the tab is a
	 * second ENTRY POINT, not a second form (see the note in `NavBar`), so the choice of WHICH dialog
	 * to open stays with the one dispatcher that already makes it.
	 */
	onOpen: () => void;
	/** So the opener can be re-focused when the dialog it opened closes. */
	ref?: React.Ref<HTMLButtonElement>;
}

/**
 * The always-present feedback tab docked to the left viewport edge (ui#1085, owner request
 * 2026-08-16). Desktop only — the breakpoint lives in `FeedbackEdgeTab.styles.ts` with the reasoning.
 *
 * It renders one button and nothing else. It owns no dialog, no open state and no auth check, because
 * making it own any of those would give the app a second answer to "where does a support note go",
 * which is the exact duplication ui#520 removed.
 *
 * The visible label is the accessible name — there is deliberately no `aria-label`, which would
 * override the word a sighted user reads with one only a screen-reader user hears.
 */
export function FeedbackEdgeTab({onOpen, ref}: FeedbackEdgeTabProps) {
	const m = useMessages();
	return (
		<EdgeTab ref={ref} type="button" onClick={onOpen}>
			{m.nav.feedbackTab}
		</EdgeTab>
	);
}
